// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mb-1";
export var rowFirst = "_mb-3";
export var rowLast = "_mb-5";
export var rowMiddle = "_mb-4";
export var ticketListScroll = "_mb-2";
export var ticketStack = "_mb-0";